import { FunctionComponent } from 'react';
import type { DefaultOptionProps } from 'vopay';
import type { ActivityTabType } from './ActivityTab';
import * as vp from 'vopay';

const { Box, PulloverSelect } = vp;

type ActivityTypeProps = {
  activityTypeOptions: DefaultOptionProps[];
  currentType: string;
  handleCurrentType: (val: ActivityTabType) => void;
};

const ActivityType: FunctionComponent<ActivityTypeProps> = ({
  activityTypeOptions,
  currentType,
  handleCurrentType,
}) => {
  const handleCurrentTypeChange = (value: string) => {
    const activityTabType: ActivityTabType = value as ActivityTabType;
    handleCurrentType(activityTabType);
  };

  return (
    <Box ai="center" gap="sm">
      <Box width="100px">Activity Type</Box>
      <Box width="300px">
        <PulloverSelect name="activityType" value={currentType} onChange={handleCurrentTypeChange}>
          {activityTypeOptions.map(({ value, label }) => (
            <PulloverSelect.Option key={value} value={value || ''}>
              {label}
            </PulloverSelect.Option>
          ))}
        </PulloverSelect>
      </Box>
    </Box>
  );
};
export default ActivityType;
